import http from "../../http-common";

const getLatest = async () => {
  return await http
    .get("/admin/changelogs/latest")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getChangelogs = async (skip, take) => {
  return await http
    .get(`/admin/changelogs?skip=${skip}&take=${take}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getLatest,
  getChangelogs,
};
